const capitaledit = {
  path: 'capitaledit/:merchantId',
  component: resolve => require(['@/pages/admin/capital/edit'], resolve),
  meta: {
    requireAuth: true
  }
}

export default capitaledit
